import axios from 'axios'
import { setupMobileInterceptors } from './mobileAuthService.js'
import { USE_JWT_COOKIE } from '../../shared/auth/authConfig.js'

/**
 * APIベースURL
 * モバイル検索用のAPIエンドポイント
 */
const API_BASE_URL = import.meta.env.VITE_API_BASE_URL || '/pix/api'

/**
 * モバイル検索用のaxiosインスタンス
 * 共通の設定とインターセプターが適用されたHTTPクライアント
 */
const apiClient = axios.create({
  baseURL: API_BASE_URL,
  withCredentials: USE_JWT_COOKIE,
  headers: {
    'Content-Type': 'application/json',
  },
})

// モバイル検索用のインターセプターを設定
setupMobileInterceptors(apiClient, 'Mobile App Search')

/**
 * 撮影メモカテゴリー取得
 * 撮影メモのカテゴリー一覧を取得
 * @returns {Promise<Object>} カテゴリー一覧データ
 */
export const getSatsueiMemoCategory = async () => {
  const response = await apiClient.post('/getSatsueiMemoCategory', {})
  return response.data
}

/**
 * PIXユーザーリスト取得
 * PIXシステムのユーザー一覧を取得
 * @returns {Promise<Object>} ユーザー一覧データ
 */
export const getPixUserList = async () => {
  const response = await apiClient.post('/getPixUserList', {})
  return response.data
}

/**
 * 拠点リスト取得
 * システム内の拠点一覧を取得
 * @returns {Promise<Object>} 拠点一覧データ
 */
export const getKyotenList = async () => {
  const response = await apiClient.post('/getKyotenList', {})
  return response.data
}

/**
 * ObjectData検索
 * 指定された条件でオブジェクトデータを検索
 * @param {Object} searchParams - 検索条件パラメータ
 * @returns {Promise<Object>} 検索結果データ
 */
export const searchObjectData = async (searchParams) => {
  const response = await apiClient.post('/getObjectList', searchParams)
  return response.data
}

/**
 * ObjectData詳細取得
 * 指定されたオブジェクトIDの詳細情報を取得
 * @param {string} objectId - オブジェクトID
 * @returns {Promise<Object>} オブジェクト詳細データ
 */
export const getObjectDetail = async (objectId) => {
  const response = await apiClient.post('/getObject', {
    objectId: objectId
  })
  return response.data
}

/**
 * モバイル検索サービス
 * オブジェクト検索、データ取得、画像取得などの検索関連機能を提供
 */
export const mobileSearchService = {
  // === データ取得 ===
  getSatsueiMemoCategory,      // 撮影メモカテゴリー取得
  getPixUserList,             // PIXユーザーリスト取得
  getKyotenList,              // 拠点リスト取得

  // === オブジェクト検索・取得 ===
  searchObjectData,            // ObjectData検索
  getObjectDetail,             // ObjectData詳細取得
}
